import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/**
 * Statuses that count as a real purchase for order-history / reorder-cadence purposes --
 * everything except Draft (never committed), Cancelled, and Rejected.
 */
export const PURCHASE_HISTORY_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.AWAITING_APPROVAL,
    SalesOrderStatus.SUBMITTED,
    SalesOrderStatus.ACCEPTED,
    SalesOrderStatus.DELIVERY_SCHEDULING,
    SalesOrderStatus.READY_TO_DELIVER,
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
]);
//# sourceMappingURL=purchase-history-sales-order-status-ids.js.map